import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/brand";

const FloatingWhatsApp = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noreferrer"
    aria-label="Fale conosco pelo WhatsApp"
    data-testid="floating-whatsapp"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.5, type: "spring", stiffness: 260 }}
    whileHover={{ scale: 1.08 }}
    className="wa-pulse fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-choco text-cream pl-4 pr-5 py-3.5 shadow-2xl"
  >
    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gold text-choco">
      <MessageCircle size={20} />
    </span>
    <span className="hidden sm:block text-xs font-semibold uppercase tracking-widest leading-tight">
      Fale conosco<br />pelo WhatsApp
    </span>
  </motion.a>
);

export default FloatingWhatsApp;
